const validateBothPasswords = (password, confirmPassword) => {
  if (!password.trim() || !confirmPassword.trim()) {
    return { error: "Password can't be empty" }
  }

  if (password !== confirmPassword) {
    return { error: 'Passwords must match' }
  }

  if (password.length < 6) {
    return { error: 'Password must be at least 6 characters long' }
  }

  if (!/[A-Z]/.test(password)) {
    return { error: 'Password must include at least one uppercase letter' }
  }

  if (!/[a-z]/.test(password)) {
    return { error: 'Password must include at least one lowercase letter' }
  }

  if (!/[0-9]/.test(password)) {
    return { error: 'Password must include at least one number' }
  }

  if (!/[!@#$%^&*(),.?":{}|<>_\-=[\]\\;/`~+]/.test(password)) {
    return { error: 'Password must include at least one special character' }
  }

  return { error: null }
}

const validatePassword = password => {
  if (!password.trim()) {
    return { error: "Password can't be empty" }
  }

  return { error: null }
}

export { validateBothPasswords, validatePassword }
